import QuizVoltaire from '../inputs/Quiz/QuizVoltaire';

window.addEventListener('DOMContentLoaded', (): void => {
    const quiz = new QuizVoltaire();
    quiz.init();
});
